diy.angular.registerFactory('diyfmsection123rf', [
    '$timeout',
    'diyl10n',
    'diyfmsectionmodel',
    'diyfmsubsectionmodel',
    'diyfmsource123rf',
    'diyfmsourcestorage',
    'diyfmconst123rf',
    'diyfmconstbigstockpurchased',
function(
    $timeout,
    diyl10n,
    diyfmsectionmodel,
    diyfmsubsectionmodel,
    diyfmsource123rf,
    diyfmsourcestorage,
    diyfmconst123rf,
    diyfmconstbigstockpurchased
) {

    // constructor
    var diyfmsection123rf = function () {
        diyfmsectionmodel.call(this, '123rfSection', diyl10n('filemanager.bigstockSection.title').replace(/&amp;/, '&')); //call parent constructor
    };

    // diyfmsection123rf extends diyfmsectionmodel
    diyfmsection123rf.prototype = Object.create(diyfmsectionmodel.prototype);

    // static methods
    diyfmsection123rf.getOrder = function() {
        return 2;
    };

    // public methods
    angular.extend(diyfmsection123rf.prototype, {
        initializeSubsections: function(sources) {
           	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);

            if (sources.indexOf(diyfmsource123rf) !== -1) {
                if (diyfmsource123rf.isAvailable()) {
                    // all photos section //
                    var _123rfSubsection = new diyfmsubsectionmodel(
                        diyfmconst123rf,
                        diyl10n('filemanager.bigstockSection.photos'),
                        diyfmsource123rf,
                        '123rfPhotos'
                    );
                    this.addSubsection(_123rfSubsection);

                    // purchased photos section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstbigstockpurchased,
                        diyl10n('filemanager.bigstockSection.purchasedPhotos').replace(/&amp;/, '&'),
                        diyfmsourcestorage,
                        '123rfPurchasedPhotos',
                        {premium: 1}
                    ));
                }
            }
        }
    });

    return diyfmsection123rf;
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sections/diyfmsection123rf.js
 ** module id = 964
 ** module chunks = 0
 **/